export const APP_NAME = 'InternetPhone';

export const SCRIPT_MTCAPTCHA = 'https://service.mtcaptcha.com/mtcv1/client/mtcaptcha.min.js';
export const SCRIPT_MTCAPTCHA2 = 'https://service2.mtcaptcha.com/mtcv1/client/mtcaptcha2.min.js';

export const MATCH_DOLLAR_SIGN_WORD = /\$\b(\w+)/;

export const ADDRESS_COOKIE = 'address';
export const ST_COOKIE_DOMAIN = '.wf-de.vodafone.com';
